import { Link } from "@tanstack/react-router";
import { ShieldCheck, ExternalLink } from "lucide-react";
import { WOODSEER_AUTHOR } from "@/lib/blog-author";

/** Visible E-E-A-T author block rendered at the end of every blog post. */
export function BlogAuthorBlock() {
  return (
    <section
      itemScope
      itemType="https://schema.org/Person"
      className="mt-12 rounded-xl border border-border bg-card p-6"
    >
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary border border-primary/20">
          <ShieldCheck className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
            Written & reviewed by
          </p>
          <h3 className="mt-1 text-base md:text-lg font-bold text-foreground">
            <span itemProp="name">{WOODSEER_AUTHOR.name}</span>
          </h3>
          <p className="text-xs text-primary font-semibold" itemProp="jobTitle">
            {WOODSEER_AUTHOR.role}
          </p>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed" itemProp="description">
            {WOODSEER_AUTHOR.bio}
          </p>
          <ul className="mt-3 space-y-1">
            {WOODSEER_AUTHOR.credentials.map((c) => (
              <li key={c} className="text-xs text-foreground/80 flex items-start gap-1.5">
                <span className="mt-1.5 h-1 w-1 rounded-full bg-primary shrink-0" />
                {c}
              </li>
            ))}
          </ul>
          <Link
            to="/official-business-information"
            className="mt-4 inline-flex items-center gap-1 text-xs font-bold text-primary hover:underline"
            itemProp="url"
          >
            View our official business record <ExternalLink className="h-3 w-3" />
          </Link>
          {WOODSEER_AUTHOR.sameAs.map((u) => (
            <link key={u} itemProp="sameAs" href={u} />
          ))}
        </div>
      </div>
    </section>
  );
}
